import React, {useEffect} from "react";
import { Typography, Button, Fade } from "@mui/material";
import { HeroSection, HeroText, CallToActionRow, CallToActionBox, HeroBackgroundImg, FeatureSection } from "./styles";
import { useNavigate } from "react-router-dom";

/**
 * Home component is the main landing page of the application.
 * It presents a hero section with a welcoming message and a start button
 * that navigates to the customer confirmation page. Below the hero section,
 * there is a call to action row with three boxes highlighting different features.
 * @returns {React.ReactElement} The Home component with Hero section and Call to action row.
 */
function Home() {
  const navigate = useNavigate();
  /**
   * Handles the click event on the 'Start' button.
   * Navigates the user to the customer confirmation route.
   */
  const handleStartClick = () => {
    window.localStorage.clear();
    navigate("/customer/identity");
  };

  return (
    <div>
      <HeroSection>
        <Fade in={true} timeout={500}>
          {/*<HeroBackgroundImg src="/assets/na-summer-open-house-hp-shd.webp" alt="Hero Image" />*/}
          <HeroBackgroundImg src="/assets/home_hero_orange.jpg" alt="Hero Image" />
        </Fade>
        <Fade in={true} timeout={1000}>
          <HeroText>
            <Typography variant="h2" gutterBottom>
                        H-D Flex Financing
            </Typography>
            <Typography variant="h5" paragraph>
                        Start your turn in now
            </Typography>
            <Button onClick={handleStartClick} variant="contained" color="secondary" size="large">
                        Start
            </Button>
          </HeroText>
        </Fade>
      </HeroSection>
      <FeatureSection>
        <Typography variant="h4">
      Not sure you want to turn-in?
        </Typography>
        <Typography variant="h6">
          Review your other end of loan options to choose which one is right for you!
        </Typography>
      </FeatureSection>
      <CallToActionRow>
        <CallToActionBox elevation={3}>
          <Typography variant="h6" gutterBottom>
            Trade-In
          </Typography>
          <Typography>
            Ready for something else? Renew your financing plan by trading in your current bike for any Harley‑Davidson® model.  Contact your local H-D Dealer to start exploring the product line-up!
          </Typography>
        </CallToActionBox>
        <CallToActionBox elevation={3}>
          <Typography variant="h6" gutterBottom>
            Payoff
          </Typography>
          <Typography>
            Love your bike and want to own it outright? Pay-off the remaining balance and own your H-D™ motorcycle.  Visit Harley-Davidson Financial Services for payoff options or contact HDFS at 800-717-3450!
          </Typography>
        </CallToActionBox>
        <CallToActionBox elevation={3}>
          <Typography variant="h6" gutterBottom>
            Refinance
          </Typography>
          <Typography>
            Enjoying the ride and don’t want to give it up? Refinance the remaining balance of your current HDFS account.  Contact your local H-D Dealer to discuss refinance options.
          </Typography>
        </CallToActionBox>
      </CallToActionRow>
    </div>
  );
}

export default Home;
